module.exports = __webpack_public_path__ + "static/media/favicon.643bc706.ico";